export default __webpack_public_path__ + "media/zurb/img/ecommerce/findability_stats-c91c8c83333f49b97245f6bf0eca660e.png";